export default __webpack_public_path__ + "static/media/img12.a68444a6.png";